// @ts-nocheck
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { GoogleMap, InfoWindow, Marker } from '@react-google-maps/api';
import { Typography } from '@mui/material';
import { useGoogleMaps } from '../../hooks/GoogleMapsContext';
import blackPin from '../../assets/images/black_pin.png';

const SchedulerMap = () => {
    const [showInfoWindow, setShowInfoWindow] = useState(false);
    const [showIndex, setShowIndex] = useState(0);

    const [defaultCenter, setDefaultCenter] = useState({
        lat: 33.302947,
        lng: -111.803276,
    });
    const { appointmentMaps } = useSelector((state: RootState) => state.appointmentScheduler);
    const { selectedMember } = useSelector((state: RootState) => state.memberDetail);
    const { loaded } = useGoogleMaps();

    const mapStyles = {
        height: (appointmentMaps?.AppointmentsNoAddress?.length ?? 0) > 0 ? 'calc(100vh - 295px)' : 'calc(100vh - 250px)',
        width: '100%',
    };

    useEffect(() => {
        if (appointmentMaps.Appointments && appointmentMaps.Appointments.length > 0) {
            var first = appointmentMaps.Appointments[0];
            if (first.Location) {
                const lat = typeof first.Location.lat === 'number' ? first.Location.lat : Number(first.Location.lat);
                const lng = typeof first.Location.lng === 'number' ? first.Location.lng : Number(first.Location.lng);
                if (!isNaN(lat) && !isNaN(lng)) {
                    setDefaultCenter({ lat, lng });
                }
            }
        }
    }, [appointmentMaps]);

    const mouseOver = (show: boolean, index: number) => {
        setShowIndex(index);
        setShowInfoWindow(show);
    };

    if (!loaded) {
        return <Typography>Loading map...</Typography>;
    }

    // Helper function to validate and convert position
    const getValidPosition = (location: any) => {
        if (!location) return null;
        const lat = typeof location.lat === 'number' ? location.lat : Number(location.lat);
        const lng = typeof location.lng === 'number' ? location.lng : Number(location.lng);
        if (isNaN(lat) || isNaN(lng)) return null;
        return { lat, lng };
    };

    // Plot every OptimizeRows entry (same set/order as the list) using Rank for the pin label.
    const appointmentsById = new Map(
        (appointmentMaps.Appointments || []).map((appt) => [appt.Id ?? appt.id, appt])
    );
    const rankedMarkers = (appointmentMaps.OptimizeRows || [])
        .map((row) => {
            const apptId = row.AppointmentId ?? row.appointmentId;
            const apptMap = appointmentsById.get(apptId);
            if (!apptMap) return null;
            const position = getValidPosition(apptMap.Location);
            if (!position) return null;
            const rank = row.Rank ?? row.rank;
            return { apptMap, position, rank };
        })
        .filter(Boolean);

    return (
        <GoogleMap mapContainerStyle={mapStyles} zoom={11} center={defaultCenter}>
            {rankedMarkers.map(({ apptMap, position, rank }) => {
                return (
                    // @ts-ignore
                    <Marker
                        onMouseOver={() => {
                            mouseOver(true, rank);
                        }}
                        onMouseOut={() => {
                            mouseOver(false, rank);
                        }}
                        zIndex={rank}
                        opacity={0.8}
                        label={{ text: rank.toString(), color: 'white', fontWeight: 'bold' }}
                        key={apptMap.id ?? apptMap.Id ?? `appointment-${rank}`}
                        position={position}
                    >
                        {
                            // @ts-ignore
                            showInfoWindow && showIndex === rank ? (
                                <InfoWindow>
                                    <>
                                        <Typography style={{ fontWeight: 'bold' }}>{'(' + rank + ') ' + apptMap.MemberName}</Typography>
                                        <hr />
                                        <Typography>{apptMap.customAddress || apptMap.address}</Typography>
                                        <br />
                                        <Typography>{apptMap.reason}</Typography>
                                    </>
                                </InfoWindow>
                            ) : null
                        }
                    </Marker>
                );
            })}
            {(() => {
                const memberHomePosition = getValidPosition(appointmentMaps.MemberHomeLocation);
                if (!memberHomePosition) return null;

                return (
                    <Marker
                        onMouseOver={() => {
                            mouseOver(true, -1);
                        }}
                        onMouseOut={() => {
                            mouseOver(false, -1);
                        }}
                        zIndex={-1}
                        opacity={0.8}
                        label={{ text: 'MA', color: 'white', fontWeight: 'bold' }}
                        key={'providerHome'}
                        style={{ color: 'purple' }}
                        position={memberHomePosition}
                        icon={blackPin}
                    >
                        {
                            // @ts-ignore
                            showInfoWindow && showIndex === -1 ? (
                                <InfoWindow>
                                    <>
                                        <Typography style={{ fontWeight: 'bold' }}>
                                            {selectedMember
                                                ? `(MA) ${selectedMember.LastName}, ${selectedMember.FirstName} — home (destination for travel)`
                                                : '(MA) Selected member home (destination for travel)'}
                                        </Typography>
                                    </>
                                </InfoWindow>
                            ) : null
                        }
                    </Marker>
                );
            })()}
        </GoogleMap>
    );
};

export default SchedulerMap;
